import Swiper from 'swiper';
import 'swiper/css';

export function initTimelineTreeSlider() {
    const treeElements = document.querySelectorAll('.timeline-tree');

    if (!treeElements.length) return;

    treeElements.forEach((treeElement) => {
        const section = treeElement.closest('section');
        if (!section) return;

        const items = treeElement.querySelectorAll('.timeline-tree-item');
        if (!items.length) return;

        const timelineSlider = section.querySelector('.timeline-slider');
        if (timelineSlider) {
            console.warn('Timeline tree and timeline slider cannot coexist in the same section');
            return;
        }

        const prevButton = section.querySelector('.timeline-prev');
        const nextButton = section.querySelector('.timeline-next');
        const yearButtons = section.querySelectorAll('.timeline-year-btn');
        const yearsSliderElement = section.querySelector('.timeline-tree-years-slider');

        let activeIndex = 0;
        let yearsSwiper = null;
        let isProgrammaticScroll = false;
        let scrollTimeout = null;

        function updateActiveYear(index) {
            yearButtons.forEach((btn, i) => {
                if (i === index) {
                    btn.classList.remove('text-black/48');
                    btn.classList.add('text-black');
                } else {
                    btn.classList.remove('text-black');
                    btn.classList.add('text-black/48');
                }
            });
        }

        function updateActiveItem(index) {
            items.forEach((item, i) => {
                if (i === index) {
                    item.classList.add('timeline-tree-item-active');
                } else {
                    item.classList.remove('timeline-tree-item-active');
                }
            });
        }

        function updateNavigationState() {
            if (prevButton) {
                if (activeIndex <= 0) {
                    prevButton.classList.add('opacity-50', 'pointer-events-none');
                } else {
                    prevButton.classList.remove('opacity-50', 'pointer-events-none');
                }
            }

            if (nextButton) {
                if (activeIndex >= items.length - 1) {
                    nextButton.classList.add('opacity-50', 'pointer-events-none');
                } else {
                    nextButton.classList.remove('opacity-50', 'pointer-events-none');
                }
            }
        }

        function scrollToItem(index) {
            if (index < 0 || index >= items.length) return;

            if (scrollTimeout) {
                clearTimeout(scrollTimeout);
            }

            isProgrammaticScroll = true;
            activeIndex = index;
            
            updateActiveYear(index);
            updateActiveItem(index);
            updateNavigationState();

            if (yearsSwiper) {
                yearsSwiper.slideTo(index, 600);
            }

            items[index].scrollIntoView({ behavior: 'smooth', block: 'center' });

            scrollTimeout = setTimeout(() => {
                isProgrammaticScroll = false;
            }, 1500);
        }

        // Initialize years swiper
        if (yearsSliderElement) {
            yearsSwiper = new Swiper(yearsSliderElement, {
                slidesPerView: 'auto',
                spaceBetween: 12,
                loop: false,
                initialSlide: 0,
                centeredSlides: false,
                slideToClickedSlide: false,
                speed: 600,
                watchOverflow: true,
                breakpoints: {
                    768: {
                        spaceBetween: 20,
                    }
                },
            });
        }

        // Year button click handlers
        yearButtons.forEach((button, index) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                scrollToItem(index);
            });
        });

        // Previous / Next button handlers
        if (prevButton) {
            prevButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                scrollToItem(activeIndex - 1);
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                scrollToItem(activeIndex + 1);
            });
        }

        // Timeline item click handlers
        items.forEach((item, index) => {
            item.addEventListener('click', () => {
                scrollToItem(index);
            });
        });

        // Detect user scroll and cancel programmatic scroll flag
        let userScrollTimeout = null;
        const treeContainer = treeElement.parentElement;
        
        const handleUserScroll = () => {
            if (userScrollTimeout) {
                clearTimeout(userScrollTimeout);
            }
            
            userScrollTimeout = setTimeout(() => {
                if (isProgrammaticScroll && scrollTimeout) {
                    clearTimeout(scrollTimeout);
                    isProgrammaticScroll = false;
                }
            }, 150);
        };

        window.addEventListener('scroll', handleUserScroll, { passive: true });

        // Track active item on scroll via IntersectionObserver
        let intersectionMap = new Map();
        let observerTimeout = null;
        
        const observer = new IntersectionObserver((entries) => {
            if (isProgrammaticScroll) return;

            entries.forEach((entry) => {
                const index = Array.from(items).indexOf(entry.target);
                if (index !== -1) {
                    intersectionMap.set(index, entry.intersectionRatio);
                }
            });

            if (observerTimeout) {
                clearTimeout(observerTimeout);
            }

            observerTimeout = setTimeout(() => {
                let maxRatio = 0;
                let maxIndex = activeIndex;
                
                intersectionMap.forEach((ratio, index) => {
                    if (ratio > maxRatio) {
                        maxRatio = ratio;
                        maxIndex = index;
                    }
                });

                if (maxRatio > 0.3 && maxIndex !== activeIndex) {
                    activeIndex = maxIndex;
                    updateActiveYear(maxIndex);
                    updateActiveItem(maxIndex);
                    updateNavigationState();

                    if (yearsSwiper) {
                        yearsSwiper.slideTo(maxIndex, 600);
                    }
                }
            }, 100);
        }, {
            root: null,
            rootMargin: '-20% 0px -20% 0px',
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
        });

        items.forEach((item) => observer.observe(item));

        // Set initial state
        updateActiveYear(0);
        updateActiveItem(0);
        updateNavigationState();
    });
}
